import { type AxiosInstance } from 'axios'
import { CancelablePromise, type OpenAPIConfig } from '../generated/api'
import { AxiosHttpRequest } from '../generated/api/core/AxiosHttpRequest'
import type { ApiRequestOptions } from '../generated/api/core/ApiRequestOptions'
import { request } from '../generated/api/core/request'

// Wrapper over AxiosHttpRequest (used by generated API client by default)
// which uses custom axios instance.
// NOTE: this class imports from `generated/api`.
export function buildCustomAxiosHttpRequest(axiosInstance: AxiosInstance) {
  return class HttpRequestCustomAxios extends AxiosHttpRequest {
    axiosInstance: AxiosInstance

    constructor(config: OpenAPIConfig) {
      super(config)

      this.axiosInstance = axiosInstance
    }

    public request<T>(options: ApiRequestOptions): CancelablePromise<T> {
      return request<T>(this.config, options, this.axiosInstance)
    }
  }
}
